import TrackingUrlProvider from './TrackingUrlProvider';
import filterUrl from './filterUrl';

export default new TrackingUrlProvider(filterUrl);
